export const Roles = {
  DEFAULT: 'default',
  DATA_VIEWER: 'Data Viewer',
  DATA_MANAGER: 'Data Manager',
  SETTINGS_MANAGER: 'Settings Manager',
  SUPER_ADMIN: 'Super Admin',
  ACTION_MANAGER: 'Action Manager',
  NPC_DECISION_MANAGER: 'NPC Decision Manager',
  IPC_MANAGER: 'IPC Manager',
  NPC_MANAGER: 'NPC Manager',
  USER_MANAGER: 'User Manager',
  ORG_ADMIN: 'Org Admin',
  BILLING_MANAGER: 'Billing Manager',
  REPORT_VIEWER: 'Report Viewer',
};

export const Permissions = {
  DASHBOARD_BASE: 'dashboard.base',
  REPORTS_BASE: 'reports.base',

  PEOPLE_BASE: 'people.base',
  PEOPLE_ADD: 'people.add',
  PEOPLE_IMPORT: 'people.import',
  PEOPLE_EXPORT: 'people.export',
  PEOPLE_BULK_DEACTIVATE: 'people.bulk_deactivate',
  PEOPLE_BULK_ADD_TAGS: 'people.bulk_add_tags',
  PEOPLE_DETAILS_EDIT: 'people.details.edit',
  PEOPLE_ACCREDITATIONS_ADD: 'people.accreditations.add',
  PEOPLE_PERMISSIONS_UPGRADE_TO_ADMIN: 'people.permissions.upgrade_to_admin',
  PEOPLE_PERMISSIONS_DOWNGRADE_FROM_ADMIN:
    'people.permissions.downgrade_from_admin',
  PEOPLE_PERMISSIONS_CHANGE_PASSWORD: 'people.permissions.change_password',

  PC_TRACKING_BASE: 'pc_tracking.base',
  PC_TRACKING_NPC_ACCEPT_DECISION: 'pc_tracking.npc.accept_decision',
  PC_TRACKING_NPC_REJECT_DECISION: 'pc_tracking.npc.reject_decision',
  ICR_TRACKING_BASE: 'icr_tracking.base',
  ACTION_TRACKING_BASE: 'action_tracking.base',

  SETTINGS_BASE: 'settings.base',
  SETTINGS_GENERAL: 'settings.general',

  SETTINGS_PROVIDERS: 'settings.providers',
  SETTINGS_PROVIDERS_NEW_SOUTH_WALES: 'settings.providers.new_south_wales',
  SETTINGS_PROVIDERS_QUEENSLAND: 'settings.providers.queensland',
  SETTINGS_PROVIDERS_SOUTH_AUSTRALIA: 'settings.providers.south_australia',
  SETTINGS_PROVIDERS_NATION_WIDE: 'settings.providers.nation_wide',

  SETTINGS_TAGS: 'settings.tags',
  SETTINGS_WEBHOOKS: 'settings.webhooks',
  SETTINGS_POLICE_CHECK: 'settings.police_checks',
  SETTINGS_SECURITY: 'settings.security',
  SETTINGS_DEFINE_TYPES: 'settings.define_types',
  SETTINGS_COMMUNITY: 'settings.community',

  BILLING_BASE: 'billing.base',
};

export const RolePermissionsMap = {
  [Roles.DEFAULT]: ['*'], // full access
  [Roles.ORG_ADMIN]: ['*'],
  [Roles.SUPER_ADMIN]: ['*'],
  [Roles.DATA_VIEWER]: [
    'dashboard.base',
    'people.base',
    'people.export',
    'people.view',
  ],
  [Roles.USER_MANAGER]: ['dashboard.*', 'people.*'],
  [Roles.DATA_MANAGER]: [
    'dashboard.*',
    'people.*',
    'settings.base',
    'settings.providers',
    'settings.providers.queensland',
    'icr_tracking.*',
  ],
  [Roles.SETTINGS_MANAGER]: ['dashboard.*', 'settings.*'],
  [Roles.NPC_MANAGER]: [
    'dashboard.*',
    'settings.base',
    'settings.police_checks',
    'pc_tracking.base',
  ],
  [Roles.NPC_DECISION_MANAGER]: [
    'dashboard.*',
    'settings.base',
    'settings.police_checks',
    'pc_tracking.base',
    'pc_tracking.npc.*',
  ],
  [Roles.IPC_MANAGER]: [
    'dashboard.*',
    'settings.base',
    'settings.police_checks',
    'pc_tracking.base',
  ],
  [Roles.ACTION_MANAGER]: ['dashboard.*', 'action_tracking.*'],
  [Roles.BILLING_MANAGER]: ['dashboard.*', 'billing.*', 'settings.base'],
  [Roles.REPORT_VIEWER]: ['dashboard.*', 'reports.*'],
};
